import { createContext } from 'react';

import type { GaugeChartThresholdIndicatorProps } from '../slots/ThresholdIndicator.js';

export const GaugeChartThresholdContext = createContext<
  GaugeChartThresholdIndicatorProps[]
>([]);
